/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { FormatedDate } from '../../Components/FormatedDate'

  // eslint-disable-next-line
  const DateCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex, i18n }) => {
    try {
      return <FormatedDate date={cellData} i18n={i18n} />;
    } catch (error) {
      return cellData;
    }
  };
  
  DateCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
    i18n: PropTypes.shape({
      lang: PropTypes.string,
      dateFormat: PropTypes.string,
      compactDateFormat: PropTypes.string,
      hourFormat: PropTypes.string,
      fullDateFormat: PropTypes.string,}
    )
  };

  DateCellRenderer.defaultProps = {
    i18n: {
      lang: 'fr',
      dateFormat: 'D MMM YYYY',
      compactDateFormat: 'D MMM YYYY',
      hourFormat: 'HH:mm:ss',
      fullDateFormat: 'D MMM YYYY / HH:mm',
    }
  }

  export default DateCellRenderer;